import React from "react";
import { GiftIcon, CheckIcon, LightbulbIcon } from "lucide-react";
import { SectionCta } from "../SectionCta";
import { bonuses } from "../../data/bonuses";
export function BonusesSection() {
  return <section className="w-full bg-cream px-3 py-16 sm:px-5 sm:py-24" data-id="element-116" data-mp="qdishy0gyio4">
      <div className="mx-auto max-w-5xl" data-id="element-117" data-mp="vbu34ayl8x7e">
        <div className="px-2" data-id="element-118" data-mp="vcllul7370g9">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-wine text-white" data-id="element-119" data-mp="vdwqen8cwc8f">
            <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-120" data-mp="1j3r2h2kupwrm" />
          </span>
          <h2 className="mt-4 text-center font-serif text-[28px] font-black leading-tight text-navy sm:text-4xl" data-id="element-121" data-mp="1nzpt6wtnjqv7">
            5 Exclusive Professional Bonuses
          </h2>
          <p className="mt-2 text-center text-lg font-bold text-cta" data-id="element-122" data-mp="1e9dcjfoykhuc">Included With Your Purchase</p>
          <p className="mx-auto mt-3 max-w-2xl text-center text-lg text-muted" data-id="element-123" data-mp="21zh4gpssat5i">
            These complementary resources help turn the concepts from the six volumes into practical
            educational exercises and reusable reference materials.
          </p>
        </div>

        <div className="mt-10 space-y-6" data-id="element-124" data-mp="2h773k6gwlwq8">
          {bonuses.map(b => <article key={b.number} className="overflow-hidden rounded-3xl bg-white shadow-sm ring-1 ring-navy/10 md:grid md:grid-cols-2" data-id="element-125" data-mp="2vvbrppyq70ge">
              <div className="bg-white md:flex md:items-center" data-id="element-126" data-mp="2r2qxinbwqlcc">
                <img src={b.image} alt={`${b.title} mockup`} className="block w-full" data-id="element-127" data-mp="34up3ipabo14a" />
              </div>
              <div className="border-t border-navy/10 px-5 py-6 sm:px-7 md:border-l md:border-t-0 md:py-8" data-id="element-128" data-mp="2zwdo7z19cyeo">
                <div className="flex flex-wrap items-center gap-2" data-id="element-129" data-mp="3etehw830f3fs">
                  <span className="rounded-md bg-wine px-3 py-1 text-xs font-extrabold uppercase tracking-widest text-white" data-id="element-130" data-mp="39w4n0cwupzkk">
                    Bonus #{b.number}
                  </span>
                  <span className="text-sm font-semibold text-muted" data-id="element-131" data-mp="1fhtzc7rztbgd">
                    Value: <s data-id="element-132" data-mp="255h8hftr8x8i">${b.value}</s>
                  </span>
                  <span className="rounded-md bg-cta px-2.5 py-1 text-xs font-extrabold uppercase tracking-wider text-white" data-id="element-133" data-mp="2570n71zrj086">
                    Included
                  </span>
                </div>
                <h3 className="mt-3 font-serif text-2xl font-bold leading-tight text-navy" data-id="element-134" data-mp="2e4ktwqge9oq6">{b.title}</h3>
                <p className="mt-2 text-muted" data-id="element-135" data-mp="2j2w26wr1jr6a">{b.description}</p>
                <p className="mt-4 text-sm font-bold uppercase tracking-wide text-navy" data-id="element-136" data-mp="2o3aa8esn714b">{b.includesLabel}</p>
                <ul className="mt-2 space-y-1.5" data-id="element-137" data-mp="2s43y58634fx7">
                  {b.items.map(item => <li key={item} className="flex gap-2.5 text-[15px] text-navy" data-id="element-138" data-mp="2wxoqokowshp0">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-139" data-mp="31uf4f1d8r179" />
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 flex gap-2.5 rounded-xl bg-cream p-4 text-[15px] text-navy" data-id="element-140" data-mp="3bufposuo7re3">
                  <LightbulbIcon className="mt-0.5 h-4 w-4 shrink-0 text-wine" aria-hidden="true" data-id="element-141" data-mp="1072g9r9calfj" />
                  <span data-id="element-142" data-mp="v6erlc8l2goh">
                    <strong className="text-wine" data-id="element-143" data-mp="v5wobvni7272">Why it’s useful:</strong> {b.why}
                  </span>
                </p>
              </div>
            </article>)}
        </div>

        <div className="px-2" data-id="element-144" data-mp="lauxmvdkxs2d">
          <SectionCta label="I want my 5 bonuses included" data-id="element-145" data-mp="1iwsjn2r64fj2" />
        </div>
      </div>
    </section>;
}